<script setup lang="ts">
defineProps<{ fillHeight?: boolean }>()
</script>

<template>
  <div :class="{ 'fill-height': fillHeight }">
    <div class="header">
      <slot name="header" />
    </div>

    <main>
      <slot name="content" />
    </main>
  </div>
</template>

<style scoped>
.header {
  position: sticky;
  top: 0;
  background-color: white;
  z-index: 1;
}

.fill-height {
  display: flex;
  flex-direction: column;
  height: 100dvh;
}

.fill-height > .header {
  flex-shrink: 0;
}

.fill-height > main {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
}
</style>
